import { NSARouterMakerResult } from "namirasoft-account-react";
import { FailoverTargetInferencerType, FailoverTargetInputRow } from "namirasoft-inference";
import { IBaseComponentProps, NSBoxInteger, NSRow } from "namirasoft-site-react";
import { Component, createRef } from "react";
import { InferenceRouterProps } from "../InferenceRouterProps";
import InferencerTypeID from "./InferencerTypeID";
import TargetLineStyles from "./TargetLine.module.css";

export interface FailoverTargetLineProps extends IBaseComponentProps, NSARouterMakerResult, InferenceRouterProps
{
	index: number;
	deletable: boolean;
	onDelete: () => void;
	onChanged?: (value: FailoverTargetInputRow | null) => void;
}

const TARGET_INFO = { link: "https://namirasoft.com/inference/console-guide/failover/#field-targets" };

const TYPE_LABEL: Record<FailoverTargetInferencerType, string> = {
	[FailoverTargetInferencerType.MODEL]: "Model",
	[FailoverTargetInferencerType.LOAD_BALANCER]: "Load Balancer",
	[FailoverTargetInferencerType.FAILOVER]: "Failover",
	[FailoverTargetInferencerType.RACE]: "Race",
	[FailoverTargetInferencerType.ROUTER]: "Router",
	[FailoverTargetInferencerType.GATEWAY]: "Gateway",
};

export default class FailoverTargetLine extends Component<FailoverTargetLineProps>
{
	static IS_DIRTY(value: FailoverTargetInputRow | null): boolean
	{
		if (value && value.inferencer_id)
			return true;
		return false;
	}

	private InferencerTypeID_Inferencer = createRef<InferencerTypeID<FailoverTargetInferencerType>>();
	private NSBoxInteger_Timeout = createRef<NSBoxInteger>();

	constructor(props: FailoverTargetLineProps)
	{
		super(props);
		this.getValue = this.getValue.bind(this);
		this.isDirty = this.isDirty.bind(this);
		this.onChanged = this.onChanged.bind(this);
	}

	getValue(checkError: boolean = false): FailoverTargetInputRow | null
	{
		let inferencer = this.InferencerTypeID_Inferencer.current?.getValue(checkError) ?? { inferencer_type: FailoverTargetInferencerType.MODEL, inferencer_id: "" };
		if (!inferencer.inferencer_id)
			return null;
		let timeout = this.NSBoxInteger_Timeout.current?.getValue(checkError) ?? 0;
		return { inferencer_type: inferencer.inferencer_type, inferencer_id: inferencer.inferencer_id, timeout };
	}

	setValue(value: FailoverTargetInputRow)
	{
		this.InferencerTypeID_Inferencer.current?.setValue({ inferencer_type: value.inferencer_type, inferencer_id: value.inferencer_id });
		this.NSBoxInteger_Timeout.current?.setValue(value.timeout);
	}

	isDirty(): boolean
	{
		return FailoverTargetLine.IS_DIRTY(this.getValue(false));
	}

	private onChanged()
	{
		if (this.props.onChanged)
			this.props.onChanged(this.getValue(false));
	}

	override render()
	{
		return (
			<NSRow style={{ ...this.props.style, flexWrap: "nowrap" }}>
				<InferencerTypeID<FailoverTargetInferencerType>
					ref={this.InferencerTypeID_Inferencer}
					{...this.props}
					typeTitle="Type"
					idTitle={(type) => `${TYPE_LABEL[type]} ${this.props.index + 1}`}
					required={false}
					fill
					getEnumObject={() => FailoverTargetInferencerType}
					defaultType={FailoverTargetInferencerType.MODEL}
					onChanged={this.onChanged}
					info={TARGET_INFO}
					menu={{
						builtin: { delete: { enabled: this.props.deletable, onDelete: () => { this.props.onDelete(); } } },
						items: []
					}}
					typeClassList={[TargetLineStyles.side_cell]}
					idClassList={[TargetLineStyles.main_cell]}
				/>
				<NSBoxInteger
					ref={this.NSBoxInteger_Timeout}
					title="Timeout (ms)"
					required={false}
					min={0}
					classList={[TargetLineStyles.side_cell]}
					info={TARGET_INFO}
					onChanged={this.onChanged}
				/>
			</NSRow>
		);
	}
}